import React from 'react'
import {Modal} from 'react-bootstrap'
import PrimaryButton from '../buttons/PrimaryButton'

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message?: string
  customContent?: React.ReactNode
  confirmButtonText?: string
  cancelButtonText?: string
  isLoading?: boolean
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  customContent,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  isLoading = false,
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{customContent ? customContent :message}</Modal.Body>
      <Modal.Footer>
        <PrimaryButton
        color='secondary'
        onClick={onClose} disabled={isLoading}>
          {cancelButtonText}
        </PrimaryButton>
        <PrimaryButton
          onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Processing...' : confirmButtonText}
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
